var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.49,
    height: 17.49
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11h-.79l-.28-.27a6.51 6.51 0 10-.7.7l.27.28v.79l5 4.99L17.49 16zm-6 0A4.5 4.5 0 1111 6.5 4.494 4.494 0 016.5 11z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy40OSIgaGVpZ2h0PSIxNy40OSIgdmlld0JveD0iMCAwIDE3LjQ5IDE3LjQ5Ij4KICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xNS41LDE0aC0uNzlsLS4yOC0uMjdhNi41MSw2LjUxLDAsMSwwLS43LjdsLjI3LjI4di43OWw1LDQuOTlMMjAuNDksMTlabS02LDBBNC41LDQuNSwwLDEsMSwxNCw5LjUsNC40OTQsNC40OTQsMCwwLDEsOS41LDE0WiIKICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTMpIgogICAgICAgICAgICBmaWxsPSIjZmZmIgogICAgLz4KPC9zdmc+";
export { SvgMagnifyingGlass as ReactComponent };